import React, { useCallback, useEffect, useState } from "react";
import CardDetails from "../../components/card-details";
import { ItemDetailsApi } from "../../api/methods-marketplace";
import { useParams } from "react-router-dom";
import CardDetailsPageLoader from "../../components/card-details/card-details-page-loader";

const ItemDetails = () => {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchItemDetails = useCallback(async () => {
    setLoading(true);
    try {
      const response = await ItemDetailsApi({ slug });
      if (response?.data) {
        setItem(response.data);
      }
    } catch (err) {
      console.error("Error fetching item details:", err);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    if (!slug) return;
    fetchItemDetails();
  }, [slug, fetchItemDetails]);

  return (
    <>
      {
        loading ? (
          <>
            <CardDetailsPageLoader />
          </>
        ) : (
            <CardDetails slug={slug} item={item} fetchItemDetails={fetchItemDetails} />
        )
      }
    </>
  );
};

export default ItemDetails;
